module.exports = __webpack_public_path__ + "img/TeamCity_icon.0a52a524.png";